<a
  mat-list-item
  [routerLink]="item().route"
  routerLinkActive="selected-item"
  [routerLinkActiveOptions]="{ exact: false }"
  #rla="routerLinkActive"
  [activated]="isMainMenuItemActive()"
  class="menu-item"
  (click)="toggleNested()"
>
  <mat-icon matListItemIcon class="material-symbols-outlined">
    {{ item().icon }}
  </mat-icon>

  @if (!collapsed()) {
    <span matListItemTitle>
      {{ item().title | translate }}
    </span>
  }

  @if(item().subItems?.length) {
    <span matListItemMeta>
      <mat-icon class="arrow-icon" [class.rotated]="nestedMenuOpen()">
        keyboard_arrow_up
      </mat-icon>
    </span>
  }
</a>

@if(!collapsed() && item().subItems && nestedMenuOpen()) {
  <div @expandContractMenu class="submenu-container">
    @for(subItem of item().subItems; track subItem.title) {
      <a
        mat-list-item
        [routerLink]="subItem.route"
        routerLinkActive="selected-item"
        [routerLinkActiveOptions]="{ exact: false }"
        #rla="routerLinkActive"
        [activated]="isRouteActive(subItem.route)"
        class="menu-item submenu-item"
        [class.indented]="!collapsed()"
      >
        @if (!collapsed()) {
          <span matListItemTitle class="submenu-item-label">
            {{ subItem.title | translate }}
          </span>
        }
      </a>
    }
  </div>
}
